/* eslint-disable */
import React from "react";
import { useEffect, useState } from "react";

import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";
import { fetchIncidents } from "../../../services/api-raindrop";
import { Link } from "react-router-dom";

const DateComponent = ({ dateStr, isExcludingTime = true }) => {
  const date = new Date(dateStr);

  let formattedDate = date.toISOString();

  if (isExcludingTime) {
    formattedDate = formattedDate.split("T")[0];
  }

  return (
    <span className="text-xs text-color-dark-text-secondary">
      {formattedDate}
    </span>
  );
};

const IncidentShortElement = ({
  incidentId,
  created_at,

  title,
}) => {
  return (
    <Link
      to={`/nimbus/incidents/${incidentId}`}
      className={`flex flex-row gap-2 items-center p-4  transition-all rounded-lg hover:scale-95 max-w-lg w-full border border-l-4
      dark:bg-color-dark-background-secondary bg-color-background-secondary
      dark:border-color-dark-border-secondary border-color-border-secondary
      dark:border-l-color-dark-model-incident border-l-color-model-incident
      hover:bg-color-background-secondary dark:hover:bg-color-dark-background-secondary
      `}
    >
      <i className="fas fa-poo-storm text-xl text-color-model-incident" />
      <div className="text-left">
        <div className="text-sm font-bold">{title}</div>
        <div className="text-xs text-color-dark-text-secondary">
          <DateComponent dateStr={created_at} />
        </div>
      </div>
    </Link>
  );
};
const NimbusIncidentsSearch = () => {
  const [incidents, setIncidents] = useState(null);

  useEffect(() => {
    fetchIncidents().then((data) => {
      console.log("🟢 (RD-059) - ", data);
      setIncidents(data);
    });
  }, []);

  if (incidents === null) {
    return <RaindropLoadingElement />;
  }

  return (
    <div className="flex flex-col justify-center text-center gap-2 items-center">
      <RaindropScrollContainer className="gap-2">
        {incidents.map((incident) => (
          <IncidentShortElement
            incidentId={incident.id}
            created_at={incident.created_at}
            declared_by={incident.declared_by}
            title={incident.title}
          />
        ))}
      </RaindropScrollContainer>
    </div>
  );
};

export default NimbusIncidentsSearch;
